import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'material-ui/Icon';
import Flag from 'react-world-flags';

const countries = require('country-data').countries;
const CONFIG = require('../../../config.json');

function extractHostname(url) {
    let hostname;
    if (url.indexOf("://") > -1) {
        hostname = url.split('/')[2];
    } else {
        hostname = url.split('/')[0];
    }
    hostname = hostname.split(':')[0];
    hostname = hostname.split('?')[0];
    return hostname;
}

const NodeDetail = ({ handleCloseDetailClick, handleTagClick, node }) => {
  const output = {};
  if (handleCloseDetailClick) {
    output.button = (
      <Icon color="action" onClick={handleCloseDetailClick} className="close-icon">close</Icon>
    );
  }

  if (node.country) {
    node.country = node.country.toUpperCase();
    output.country = node.country;
    if (countries[output.country]) {
      output.country = countries[output.country].name;
    }
    output.flag = (
      <Flag code={node.country} height="16" className="flag" />
    );
  }

  output.tags = [];
  let tags = [];
  if (node.tags) {
    tags = node.tags;
    tags = tags.split(',');
  }
  let index = 0;
  let key = new Date().getTime();
  for (const tag of tags) {
    key += index;
    output.tags.push(
      <div className='tag' key={key} onClick={() => handleTagClick({ tag })}>{tag}</div>
    );
    index++;
  }

  output.references = [];
  let references = [];
  if( node.reference ) {
      references.push(node.reference);
  }
  if( node.references ) {
    references.push(node.references);
  }
  index = 0;
  key = new Date().getTime();
  for (let reference of references) {
      key += index;
    output.references.push(
        <div key={key}>
            <a className="reference" href={reference} target="_blank">{extractHostname(reference)}</a>
        </div>
    );
    index++;
  }

  const page = node.page+'';
  if( page ) {
    const splits = page.split(',');
    let pages = [];
    for( let split of splits ) {
      pages.push(split);
    }
    output.report = [];
    key = new Date().getTime();
    index = 0;
    for( let item of pages ) {
      const page_index = CONFIG.reportPageOffset + Number(item.trim());
      let str = '';
      if( index === 0 ) {
        str = 'View full report: page ' + item;
      } else {
        str = item;
      }
      if( index !== pages.length - 1 )
        str += ', ';
      output.report.push(
        <a key={key} href={CONFIG.reportPDFLink+'#page='+page_index} target="_blank">{str}</a>
      );
      key += 1;
      index++;
    }
  }

  return (
    <div className="node-panel">
        <div className="detail">
            <div className="info">
                <div className="name"><h3>{node.label}</h3></div>
                {
                    (node.alias) ? 
                        (<div className="alias"><h4>Alias : {node.alias}</h4></div>)
                        : (<div></div>)
                }
            </div>
            <div className="photo">
                <img src={node.image} alt='photo' width='100' height='100' />
            </div>
            {output.button}
        </div>
        <div className="info-detail">
            <div className="type">Type : {node.type}</div>
            <div className="country">Country : {output.country} {output.flag}</div>
        </div>
        <div className="description">
            {node.description}
        </div>
        <div className="report">
            {output.report}
        </div>
        <div className="references">
            {output.references}
        </div>
    </div>
  );
};

NodeDetail.propTypes = {
  node: PropTypes.object,
  handleCloseDetailClick: PropTypes.func,
  handleTagClick: PropTypes.func,
};

export default NodeDetail;



// WEBPACK FOOTER //
// ./scripts/components/NodeDetail.jsx